import { DeleteOutlineOutlined } from "@mui/icons-material";
import { Button, Col, Input, message, Row, Table } from "antd";
import COLORS from "common/Colors";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getAllDepartmentList } from "redux/selectors";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import styled from "styled-components";
import GridBuilder from "UIBuilderEngine/GridBuilder";

const BasicAndKPIWrap = styled.div`
  .footer-content {
    cursor: pointer;
    width: 100%;
    text-align: center;
    color: #2d53da;
    background: #e3e8fc;
    border-radius: 5px;
    padding: 8px 0;
  }
`;

const StyledTable = styled(Table)`
  .ant-table {
    border: 1px solid #ccc;
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 12px;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 900px;
  }

  .ant-table-cell {
    padding: 16px;
    white-space: nowrap;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .ant-table-tbody > tr > td {
    border-bottom: none !important;
  }

  .reason-column {
    min-width: 280px;
    white-space: normal;
  }

  .non-white {
    background: #f9f9f9;
  }

  @media (max-width: 768px) {
    .ant-table-cell {
      padding: 10px;
      font-size: 12px;
    }
  }
`;

const BasicAndKPI = ({
  setStep,
  step,
  tableData,
  setTableData,
  setIsAddEditTemplate,
  status,
  setStatus,
  data,
  setData,
  onSubmitClick,
  loading,
  draftLoading,
  scrollToTop,
  validateAll,
}) => {
  console.log("data-->", data);
  const departmentList = useSelector(getAllDepartmentList);

  const [weightageError, setWeightageError] = useState("");
  const [total, setTotal] = useState(0);
  const [invalidFields, setInvalidFields] = useState({
    strategic: [],
    previous: [],
    upcoming: [],
    bdo: [],
  });

  const handleTableDataChange = (index, field, value) => {
    const updated = tableData.map((item, idx) =>
      idx === index ? { ...item, [field]: value } : item
    );
    setTableData(updated);
    if (field === "weightage") {
      const total = updated.reduce(
        (sum, item) => sum + (parseFloat(item.weightage) || 0),
        0
      );

      setTotal(total);

      setWeightageError(
        total !== 100 ? "Total weightage must be exactly 100%" : ""
      );
    }

    // Clear validation error for this field
    setInvalidFields((prev) => {
      const updated = { ...prev };
      if (updated.strategic.includes(index)) {
        if (value) {
          updated.strategic = updated.strategic.filter((i) => i !== index);
        }
      }
      return updated;
    });

    // Check if current row is complete and is the last row
    const currentRow = updated[index];
    const isLastRow = index === updated.length - 1;
    const isCurrentRowComplete =
      currentRow.kpicategory !== "" &&
      currentRow.kpicategory !== null &&
      currentRow.kpidescription !== "" &&
      currentRow.kpidescription !== null &&
      currentRow.expectedoutcomes !== "" &&
      currentRow.expectedoutcomes !== null &&
      currentRow.weightage !== "" &&
      currentRow.weightage !== null;

    // Auto-add new row if current row is complete, it's the last row, and we haven't reached 10 rows
    // if (isLastRow && isCurrentRowComplete && tableData.length < 10) {
    //   const newRow = {
    //     id: updated.length + 1,
    //     kpicategory: "",
    //     kpidescription: "",
    //     expectedoutcomes: "",
    //     weightage: "",
    //   };
    //   setTableData([...updated, newRow]);
    // }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      width: "10%",
    },
    {
      title: <div style={{ whiteSpace: "wrap" }}>KPI Category</div>,
      dataIndex: "kpicategory",
      key: "kpicategory",
      width: "30%",
      render: (text, record, index) => (
        <>
          {status === "view" ? (
            record?.kpicategory
          ) : (
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 6 }}
              value={record?.kpicategory}
              style={{
                width: "100%",
                border:
                  invalidFields.strategic.includes(index) && !record.kpicategory
                    ? "1px solid red"
                    : "",
              }}
              status={
                invalidFields.strategic.includes(index) && !record.kpicategory
                  ? "error"
                  : ""
              }
              onChange={(e) =>
                handleTableDataChange(index, "kpicategory", e.target.value)
              }
            />
          )}
        </>
      ),
    },
    {
      title: "KPI Name & Description",
      dataIndex: "kpidescription",
      key: "kpidescription",
      width: "30%",
      render: (text, record, index) => (
        <>
          {status === "view" ? (
            record?.kpidescription
          ) : (
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 6 }}
              value={record?.kpidescription}
              style={{
                width: "100%",
                border:
                  invalidFields.strategic.includes(index) &&
                  !record.kpidescription
                    ? "1px solid red"
                    : "",
              }}
              status={
                invalidFields.strategic.includes(index) &&
                !record.kpidescription
                  ? "error"
                  : ""
              }
              onChange={(e) =>
                handleTableDataChange(index, "kpidescription", e.target.value)
              }
            />
          )}
        </>
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedoutcomes",
      key: "expectedoutcomes",
      width: "30%",
      render: (text, record, index) => (
        <>
          {status === "view" ? (
            record?.expectedoutcomes
          ) : (
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 6 }}
              value={record?.expectedoutcomes}
              style={{
                width: "100%",
                border:
                  invalidFields.strategic.includes(index) &&
                  !record.expectedoutcomes
                    ? "1px solid red"
                    : "",
              }}
              status={
                invalidFields.strategic.includes(index) &&
                !record.expectedoutcomes
                  ? "error"
                  : ""
              }
              onChange={(e) =>
                handleTableDataChange(index, "expectedoutcomes", e.target.value)
              }
            />
          )}
        </>
      ),
    },
    {
      title: "Weightage (%)",
      dataIndex: "weightage",
      key: "weightage",
      width: "10%",
      render: (text, record, index) => (
        <>
          {status === "view" ? (
            record?.weightage
          ) : (
            <Input
              value={record?.weightage}
              style={{
                border:
                  invalidFields.strategic.includes(index) && !record.weightage
                    ? "1px solid red"
                    : "",
              }}
              status={
                invalidFields.strategic.includes(index) && !record.weightage
                  ? "error"
                  : ""
              }
              onKeyDown={(event) => {
                if (
                  !/[0-9]/.test(event.key) &&
                  event.key !== "Backspace" &&
                  event.key !== "Tab"
                ) {
                  event.preventDefault();
                }
              }}
              maxLength={10}
              onChange={(e) =>
                handleTableDataChange(index, "weightage", e.target.value)
              }
            />
          )}
        </>
      ),
    },
    {
      title: "",
      key: "action",
      render: (text, record, index) => {
        const isLastRow = tableData[tableData.length - 1]?.id === record.id;
        return (
          tableData?.length !== 1 && (
            <DeleteOutlineOutlined
              disabled={tableData?.length === 1}
              onClick={() => handleDeleteRow(record.id)}
              style={{ color: "#2D53DA", cursor: "pointer" }}
            >
              Delete
            </DeleteOutlineOutlined>
          )
        );
      },
    },
  ];

  const handleAddRow = () => {
    const lastRow = tableData[tableData.length - 1];

    // Check if last row is complete
    if (
      (!lastRow ||
        !lastRow.kpicategory ||
        !lastRow.kpidescription ||
        !lastRow.expectedoutcomes ||
        !lastRow.weightage) &&
      tableData?.length
    ) {
      message.error(
        "Please complete all fields in the current row before adding another"
      );
      // Highlight the incomplete row
      if (lastRow) {
        setInvalidFields((prev) => ({
          ...prev,
          strategic: [...prev.strategic, tableData.length - 1],
        }));
      }
      return;
    }

    const newRow = {
      id: tableData.length + 1,
      kpicategory: "",
      kpidescription: "",
      expectedoutcomes: "",
      weightage: "",
    };

    setTableData([...tableData, newRow]);
  };

  const handleDeleteRow = (id) => {
    const filteredData = tableData.filter((item) => item.id !== id);

    const updatedData = filteredData.map((item, index) => ({
      ...item,
      id: index + 1,
    }));

    setTableData(updatedData);
  };

  // Validate table
  const validateTable = () => {
    let isValid = true;
    const invalidRows = [];

    // Check if table has at least one row
    if (tableData.length === 0) {
      message.error("Please add at least one KPI row");
      return;
    }

    // Validate all rows
    tableData.forEach((row, index) => {
      if (
        !row.kpicategory ||
        !row.kpidescription ||
        !row.expectedoutcomes ||
        !row.weightage
      ) {
        invalidRows.push(index);
        isValid = false;
      }
    });

    // Update validation state
    setInvalidFields((prev) => ({
      ...prev,
      strategic: invalidRows,
    }));

    // Check weightage total
    const total = tableData.reduce(
      (sum, item) => sum + (parseFloat(item.weightage) || 0),
      0
    );

    if (total !== 100) {
      setWeightageError("Total weightage must be exactly 100%");
      isValid = false;
    }

    if (!isValid) {
      message.error(
        "Please fill in all required fields and ensure weightage totals 100%"
      );
    }

    return isValid;
  };

  const footerStyle = {
    position: "sticky",
    bottom: -20,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  const AppraisalFormData = {
    pages: [
      {
        modalView: false,
        colSpan: [12, 12],
        fields: [
          ...(status !== "view"
            ? [
                [
                  {
                    id: 1,
                    label: "Name of the template (Eg: Senior Frontend)",
                    type: "text",
                    name: "templatename",
                    maxLength: 65,
                    validationRules: [
                      {
                        required: true,
                        message: "Template Name is Required",
                      },
                    ],
                  },
                  {
                    id: 2,
                    label:
                      "Departments to which this template should be available for",
                    type: "selectwithvalue",
                    name: "availabledepartments",
                    mode: "multiple",
                    validationRules: [
                      {
                        required: true,
                        message: "Department is required",
                      },
                    ],
                    options: departmentList?.map((item) => ({
                      label: item?.department_name,
                      value: item?.department_id,
                    })),
                  },
                ],
              ]
            : []),

          ...(status !== "view"
            ? [
                [
                  {
                    id: 3,
                    label: "Status of the Template",
                    type: "select",
                    name: "templatestatus",
                    validationRules: [
                      {
                        required: true,
                        message: "Template Status is required",
                      },
                    ],
                    options: ["Active", "Inactive"],
                  },
                  {
                    id: 4,
                  },
                ],
              ]
            : []),
          [
            {
              id: 32,
              type: "div",
              content: (
                <div>
                  {status === "view" && (
                    <div className="mb-3">
                      <Row gutter={[16, 16]}>
                        <Col xs={24} md={12}>
                          <Row gutter={16}>
                            <Col xs={24} md={12} className="lite-text">
                              Name of the Employee
                            </Col>
                            <Col xs={24} md={12}>
                              {data?.templatename || "-"}
                            </Col>
                          </Row>
                        </Col>

                        <Col xs={24} md={12}>
                          <Row gutter={16}>
                            <Col xs={24} md={12} className="lite-text">
                              Departments to which this template should be
                              available for
                            </Col>
                            <Col xs={24} md={12}>
                              {departmentList
                                ?.filter((item) =>
                                  data?.availabledepartments?.includes(
                                    item?.department_id
                                  )
                                )
                                ?.map((item) => item?.department_name)
                                ?.join(", ")}
                            </Col>
                          </Row>
                        </Col>

                        <Col xs={24} md={12}>
                          <Row gutter={16}>
                            <Col xs={24} md={12} className="lite-text">
                              Period
                            </Col>
                            <Col xs={24} md={12}>
                              {data?.templatestatus || "-"}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )}
                  <h6>Setup the KPI for the role</h6>
                  <StyledTable
                    dataSource={tableData}
                    columns={columns}
                    className="small_table mb-3"
                    rowKey="key"
                    pagination={false}
                  />
                  {weightageError && (
                    <div style={{ color: "red" }}>{weightageError}</div>
                  )}
                  {status !== "view" && (
                    <>
                      {total < 100 && (
                        <div
                          className="footer-content mb-3"
                          onClick={handleAddRow}
                        >
                          + Add another row
                        </div>
                      )}
                      <div style={footerStyle}>
                        <ButtonOutlined
                          onClick={() => {
                            setStatus("");
                            setIsAddEditTemplate(false);
                          }}
                        >
                          Cancel
                        </ButtonOutlined>
                        {status !== "edit" && (
                          <ButtonOutlined
                            loading={draftLoading}
                            type="primary"
                            onClick={() => {
                              if (data?.templatename) {
                                onSubmitClick("draft");
                              } else {
                                message.error(
                                  "Please fill the template name before saving as draft"
                                );
                              }
                            }}
                          >
                            Save as Draft
                          </ButtonOutlined>
                        )}
                        <ButtonFilled
                          loading={loading}
                          type="primary"
                          htmlType="submit"
                          onClick={() => {
                            const validate = validateTable();
                            if (validate && status !== "edit") {
                              scrollToTop();
                              setStep(step + 1);
                            } else if (validate && status === "edit") {
                              if (!validateAll()) return;
                              onSubmitClick("final");
                            }
                          }}
                        >
                          {status === "edit" ? "Update" : "Next"}
                        </ButtonFilled>
                      </div>
                    </>
                  )}
                </div>
              ),
            },
          ],
        ],
      },
    ],
  };

  const handleFormChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (value, name) => {
    setData({
      ...data,
      [name]: value,
    });
  };
  return (
    <BasicAndKPIWrap>
      <GridBuilder
        formStructureJson={AppraisalFormData}
        initialValues={data}
        handleSelectChange={handleSelectChange}
        handleChange={handleFormChange}
        // formSubmit={onSubmitClick}
      />
    </BasicAndKPIWrap>
  );
};

export default BasicAndKPI;
